import React from 'react'
// import { }
import { db, auth } from './firebase'
import logo from './logo.png'

import CPFInput from './CPFInput'
// import firebase from 'firebase'

import { startLogin, setForm } from './redux/reducers'
import { connect } from 'react-redux'

import { history } from './history'

// let cpf = localStorage.getItem('login') || ''
let cpf = ''
// let password = ''
if (process.env.NODE_ENV === 'development') {
  // cpf = '223.420.888-25'
}

const blankFormData = {
  nome: '',
  cpf: '',
  raw: '',
  rg: '',
  nasc: '',
  nascValue: 0,
  email: '',
  tel: '', 
  sexo: '-',
  comoConheceu: '-',
  comoConheceuDetalhes: '',
  contatoEmergenciaNome: '',
  contatoEmergenciaTel: '',
  contatoEmergenciaGrau: '',

  uf: '',
  cidade: '',
  regiao: '',
  carro: '-',
  moto: '-',
  disponibilidade: {fds: false, manhã: false, noite: false, tarde: false,},
  disponibilidadeObs: '',

  pics: [],
  facebook: '',
  instagram: '',
  idiomas: {
    português: true,
    francês: false,
    inglês: false,
    alemão: false,
    espanhol: false,
    mandarim: false,
    russo: false,
  },
  idiomasOutros: '',
  experiencias: '',

  etnia: '-',
  cabeloComprimento: '-',
  cabeloCor: '-',
  cabeloTipo: '-',
  manequim: '',
  sapato: '',
  altura: '',
  cintura: '',
  quadril: '',
  busto: '',
  plusSize: '-',
  pcd: '-',
  deficiencias: {
    física: false,
    visual: false,
    auditiva: false,
    intelectual: false,
  },
  deficienciaObs: '',
  oQueMais: '',

  bancoTipo: 'pix',
  bancoPix: '',
  bancoBanco: '',
  bancoAgencia: '',
  bancoConta: '',
  bancoTipoConta: 'corrente',
  bancoTitular: '',
  bancoCPF: '',

}


export class LoginPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      cpf: localStorage.getItem('login') || cpf,
      raw: cpf.replace(/\./g, '').replace(/-/g, '').replace(/_/g, ''),
      // password,
      error: null,

      // loading: true,
      loading: false,
      loadingMessage: 'Aguarde...',
    }
    // const db = firebase.firestore()
  }

  componentDidMount() {
    console.log('CDM')
    this.setState({cpf: localStorage.getItem('login') || ''})
  }

  onUserChange = (e) => {
    const cpf = e.target.value
    this.setState({cpf: cpf})
    // console.log(cpf)
    //console.log('user: ',user)
  }
  
  onPassChange = (e) => {
    const password = e.target.value;
    this.setState({password})
  }
  
  doLogin = (cpf) => {
    // console.log('Logging in', cpf)
      this.setState({loading: true})

      this.props.setForm({...blankFormData})

      localStorage.setItem('login', cpf)
      const docRef = db.collection('people').doc(cpf)
      // let formData = {}

      console.log('start login process')

      auth.signInAnonymously().then((res) => {
      docRef.get().then((doc) => {
        if (doc.exists) {
          console.log(doc.data())
          // formData = {cpf: this.state.cpf, raw: this.state.raw, newUser: false, ...doc.data()}
          // auth.signInAnonymously().then((res) => {
          // auth.signInWithEmailAndPassword('newuser@maniadeeventos.com.br', '123456').then((res) => {
            // console.log('Auth returned', res)

            this.props.startLogin({...res.user})

            // let listRef = storage.getReference().child(`images/${cpf}`)
            // let listRef = firebaseApp.storage().child(`images`)
            // // let images = []
            // // let listRef = storage.ref(`images/${cpf}`)
            // // listRef.listAll()
            // //   .then(({items}) => {
            // //     console.log('ITEMS is', items)
            // //     images = items.map((i) => i.fullPath)
            // //     console.log ('IMAGES is', images)
            //     this.props.setForm({cpf: this.state.cpf, raw: this.state.raw, newUser: false, pics: images, ...doc.data()})
            //   }).catch((err) => {
            //     console.log('error', err)
            //     this.props.setForm({cpf: this.state.cpf, raw: this.state.raw, newUser: false, pics: images, ...doc.data()})
            //   })
                // this.props.setForm({...blankFormData})
                const data = {
                  // ...blankFormData,
                  ...doc.data(),
                }
                this.props.setForm({cpf: this.state.cpf, raw: this.state.raw, newUser: false, ...data})
                // this.props.setForm({cpf: this.state.cpf, raw: this.state.raw, newUser: false, ...doc.data()})

            // console.log('will push form page')

            
            history.push(`/form`)
              // })
        } else {
          console.log('Not found!')
          // formData = {cpf: this.state.cpf, raw: this.state.raw, newUser: true}
          // auth.signInAnonymously().then((res) => {
          // auth.signInWithEmailAndPassword('newuser@maniadeeventos.com.br', '123456').then((res) => {
            console.log('Auth returned', res)
            
            this.props.startLogin({...res.user})
            this.props.setForm({cpf: this.state.cpf, raw: this.state.raw, newUser: true, createdAt: new Date().valueOf()})

            // console.log('will push form page')

            history.push(`/form`)
    
          // })
        }
        this.setState({loading: false})
        // global.cpf = this.state.cpf
        // this.props.navigation.navigate('')

      })
      }).catch((err) => {
        console.log(err)
        this.setState({loading: false})
      })
  }

  onSubmit = (e) => {
    e.preventDefault()
    this.doLogin(this.state.raw)
    }

  

render(){
  return(
    <div style={{
      // backgroundColor: 'blue',
      height: '100vh',
      width: '100vw',
      justifyContent: 'flex-start',
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'column',
      // padding: '20px',
    }}
    >
      <div style={{
        flex: 0,
        display: 'block',
        textAlign: 'center',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: 20,
        marginTop: 20,
        // paddingLeft: '10%',
        // paddingRight: '10%',
        // minWidth: '100%',
        // alignSelf: 'stretch',
        // background: 'blue',

      }}>
        
        <a href='https://www.maniadeeventos.com.br' target="_blank" rel="noopener noreferrer">
          <img src={logo} style={{maxWidth: '80%', flex: 0, textAlign: 'center',}} alt="Mania de Eventos" />
        </a>
      </div>
      <div style={{
        justifySelf: 'center',
        flex: 1,
        display: 'flex',
        height: '100%',
        flexDirection: 'row',
        alignItems: 'flex-start',
        justifyContent: 'stretch',
        paddingTop: '30px',
        paddingBottom: '30px',
        backgroundColor: '#ECECEC',
        // backgroundColor: '#F4868D',
        alignSelf: 'center',
        width: '80%',
        // overflow: 'hidden',
        // overflowY: 'auto',
        // scrollbarColor: '#d60404',
        boxShadow: '6px 6px rgba(0,0,0,0.25)',
        borderRadius: '30px',
        // overflowY: 'scroll',
      }}>

    
    <div
      style={{
        // height: '90%',
        // flex: 1,
        width: '100%',
        
        display: 'flex',
        // padding: '16px',
        alignItems: 'stretch',
        justifyContent: 'center',
        // overflowY: 'auto',
        borderRadius: '30px',
      }}>
      <div style={{flex: 1,}}>
        <div style={{
          flex: 0, textAlign: 'center', padding: 8,
        }}>
          A <b>Mania de Eventos</b> te dá as boas vindas ao nosso time!<br /><br />
          Para continuar, por favor informe seu CPF.
        </div>
        <div style={{
          flex: 1,
          height: '100%',
          display: 'flex',
          // background: 'green',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          marginTop: 20,
        }}>
        <form onSubmit={this.onSubmit} className="form"
          style={{
            alignItems: 'center'
          }}>
          <div style={{
            width: 200,
            textAlign: 'center'
            // display: 'flex',
            // flexDirection: 'column',
            // flex: 1,
            // background: 'blue',
          }}>
          <CPFInput name="cpf" className="login-text"
            value={this.state.cpf}
            disabled={this.state.loading}
            showValidStatus={false}
            textAlign={'center'}
            onChange = {(cpf, raw, valid) => {
              this.setState({cpf, raw, isCPFValid: valid, error: raw.length === 11 && !valid ? 'CPF inválido' : ''})
              // console.log(cpf, raw)
            }}
            placeholder="CPF" autoFocus={true}
          />
        {
          !!this.state.error &&
          <div className="login-error">{this.state.error}</div>
        }
          <button
            disabled={!this.state.cpf || !this.state.isCPFValid || this.state.loading}
            className="login-button"
          >{this.state.loading ? 'Carregando...' : 'Continuar >'}</button>
        </div>
        </form>
        </div>
        </div>
      
    
    </div>
    </div>
      <div style={{flex: 0, minHeight: 80}}></div>
    </div>

  )
  }
}
const mapDispatchToProps = (dispatch) => ({
  startLogin: (user, password) => dispatch(startLogin(user, password)),
  setForm: (data) => dispatch(setForm(data)),
})

export default connect(undefined, mapDispatchToProps)(LoginPage)
// export default LoginPage